import React, { useEffect, useRef, useState, useContext } from "react";

import { Button } from "primereact/button";
import { Toast } from "primereact/toast";

import Card from "../../../Components/Card/Card";
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";
import AgGrid from "../../../Components/Tables/AgGrid/AgGrid";

import { setTitlePage } from "../../../Services/Config/ConfigService";
import { getMetricas } from "../../../API/IT/Metricas/MetricasRequest";
import { Checkbox } from "primereact/checkbox";
import MetricasCRUD from "./MetricasCRUD";


const MetricasScreen = () => {
  const toast = useRef(null);
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [metricas, setMetricas] = useState([]);
  const [selected, setSelected] = useState([]);
  const [showDialog, setShowDialog] = useState(false);

  const getInfo = async () => {
    setLoading(true);
    const d = await getMetricas();
    setMetricas(d);
    setLoading(false);
  };



  const columns = [
    {
      field: "IdMetrica",
      header: "ID",
      headerEn:"ID",
      hidden: userAuth.IdRol === 1,
      className: "XXsmall",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
      field: "Nombre",
      header: "Nombre",
      headerEn:"Name",
      className: "large",
      onCellDoubleClicked: ({ data }) => {
        setShowDialog(true);
        setSelected(data);
      },
    },
    {
        field: "Menu",
        header: "Menu",
        headerEn:"Menu",
        className: "large",
        flex:1,
        onCellDoubleClicked: ({ data }) => {
          setShowDialog(true);
          setSelected(data);
        },
    },
    {
        field: "Descripcion",
        header: "Descripción",
        headerEn:"Description",
        className: "large",
        onCellDoubleClicked: ({ data }) => {
          setShowDialog(true);
          setSelected(data);
        },
    },
    {
        field: "Pm2",
        header: "Pm2",
        headerEn:"Pm2",
        Format: "Template", 
        filter: false,
        body: (rowData) => {
          return (
            rowData.IdMetrica ? <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '2px' }}>
              <Checkbox
                checked={rowData.Pm2 === true}
              />
            </div> : null
          );
        }
    },
    {
      field: "IdMetrica",
      Format: "Botones",
      filter: false,
      Botones: [
        {
          icon: "pi pi-pencil",
          tooltip: "Editar",
          onClick: (rowData) => {
            setShowDialog(true);
            setSelected(rowData);
          },
          tooltipOptions: {
            position: "left",
          },
        },
      ],
    },
  ];

  const table = {
    Columns: columns,
    Data: metricas,
    loading: loading,
  };


  useEffect(() => {
    setTitlePage(getLabel(baseLang, "metricas", config.language));
    getInfo();
  }, []);

  return (
    <div
    className=" p-fluid px-4"
    style={{ width: "100%", height: "100%", margin: "auto" }}
    >
      <Toast ref={toast} />
      <Card
        titulo={
          <div className="botones">
            <h3>{getLabel(baseLang, "metricas", config.language)}</h3>
            <Button icon="pi pi-refresh" onClick={getInfo} />
            <Button
              icon="pi pi-plus"
              severity="success"
              onClick={() => {
                setShowDialog(true);
                setSelected(null);
              }}
            />
          </div>
        }
        contenido={
          <div className="p-4" style={{ height: "90vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />

      {showDialog && (
        <MetricasCRUD
            showDialog={showDialog}
            selected={selected}
            setShowDialog={setShowDialog}
            getInfo={getInfo}
            modo={selected ? "Editar" : "Crear"}
        />
      )}
    </div>
  );
};

export default MetricasScreen;
